module.exports = __webpack_public_path__ + "static/media/SG.bf16390b.png";